import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuesService } from '../../providers/ques.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardService } from '../../providers/dashboard.service';
import { LoginModal } from '../header/header.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../providers/login.service';
import * as CryptoJS from 'crypto-js';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { JSONIDService } from '../../providers/schema';
import { Config } from '../components/faqs/faqs.component';
import { CoursesService } from 'src/providers/courses.service';
import { CartService } from 'src/providers/cart.service';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTooltip } from '@angular/material/tooltip';
import { ConstantService } from 'src/providers/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { Buffer } from 'buffer';

declare var $: any;

export interface MockData {
  "section_name": string,
  "noofquest": string,
  "eachmarks": string,
  "instructions": string,
  "time": string,
}



@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
  config!: Config;
  options: Config = { multi: false };

  displayedColumns: string[] = ['section_name', 'noofquest', 'eachmarks', 'time', 'TakeTest'];
  dataSource!: MatTableDataSource<MockData>;


  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;


  pastList: any[] = [
    { name: 'CUET 2023 ENGLISH', type: 'full', lock: true, paid: false, launch: '', _id: "660e3baaa59236452d8f5ea6", setId: '661cee70a3ecc25720f17ac3', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 GENERAL TEST MOCK 1', type: 'full', lock: true, paid: false, launch: '', _id: "66150f59a59236452d8fa7fe", setId: '661ceef3a3ecc25720f17ac4', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 GENERAL TEST MOCK 2', type: 'full', lock: true, paid: false, launch: '', _id: "66151624a59236452d8fa924", setId: '661ceef3a3ecc25720f17ac4', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 GENERAL TEST MOCK 3', type: 'full', lock: true, paid: false, launch: '', _id: "661519daa59236452d8fab04", setId: '661ceef3a3ecc25720f17ac4', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 GENERAL TEST MOCK 4', type: 'full', lock: true, paid: false, launch: '', _id: "66151cefa59236452d8fabbd", setId: '661ceef3a3ecc25720f17ac4', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 POLITICAL', type: 'full', lock: true, paid: false, launch: '', _id: "66150368a59236452d8fa5d9", setId: '661cebe2a3ecc25720f17ac0', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 HISTORY', type: 'full', lock: true, paid: false, launch: '', _id: "661505fca59236452d8fa61b", setId: '661cec5fa3ecc25720f17ac1', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 GEOGRAPHY', type: 'full', lock: true, paid: false, launch: '', _id: "66150487a59236452d8fa5ec", setId: '661cecc4a3ecc25720f17ac2', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 ACCOUNTANCY', type: 'full', lock: true, paid: false, launch: '', _id: "660e370ea59236452d8f5dde", setId: '661cef22a3ecc25720f17ac5', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 BUSINESS STUDIES', type: 'full', lock: true, paid: false, launch: '', _id: "660e30e8a59236452d8f5c64", setId: '661cef9ea3ecc25720f17ac6', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 ECONOMICS', type: 'full', lock: true, paid: false, launch: '', _id: "660e39aea59236452d8f5e05", setId: '661cefd5a3ecc25720f17ac7', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 MATHEMATICS', type: 'full', lock: true, paid: false, launch: '', _id: "66150a27a59236452d8fa72d", setId: '661cf01da3ecc25720f17ac8', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 PSYCHOLOGY', type: 'full', lock: true, paid: false, launch: '', _id: "661651f4a59236452d8fbe1a", setId: '661cf1dca3ecc25720f17acf', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 PHYSICS', type: 'full', lock: true, paid: false, launch: '', _id: "6615200aa59236452d8fac00", setId: '661cf1f2a3ecc25720f17ad0', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 CHEMISTRY', type: 'full', lock: true, paid: false, launch: '', _id: "66164f31a59236452d8fbd80", setId: '661cf077a3ecc25720f17ac9', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 BIOLOGY', type: 'full', lock: true, paid: false, launch: '', _id: "66165482a59236452d8fbe62", setId: '661cf0a2a3ecc25720f17aca', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 Sociology', type: 'full', lock: true, paid: false, launch: '', _id: "66178fc5a59236452d8fdd6b", setId: '661cf0d9a3ecc25720f17acb', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 Computer science', type: 'full', lock: true, paid: false, launch: '', _id: "661791bca59236452d8fdd82", setId: '661cf0fda3ecc25720f17acc', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 Enterpreneurship', type: 'full', lock: true, paid: false, launch: '', _id: "66168a4aa59236452d8fd043", setId: '661cf147a3ecc25720f17acd', link: 'https://iverse.iquanta.in/' },
    { name: 'CUET 2023 Physical Education', type: 'full', lock: true, paid: false, launch: '', _id: "6617930fa59236452d8fdd99", setId: '661cf19aa3ecc25720f17ace', link: 'https://iverse.iquanta.in/' },
  ];

  fullmockDetailList: any[] = [
    { name: 'English Language 1.0', type: 'full', lock: false, paid: false, launch: '', _id: "65b89a3193eb5afce540c1e6", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 2.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b89bab93eb5afce540c205", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 3.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b89fdc93eb5afce540c2d3", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 4.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a0d893eb5afce540c2ed", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 5.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a1fb93eb5afce540c304", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 6.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a2e093eb5afce540c32c", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 7.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a4d493eb5afce540c340", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 8.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a5e093eb5afce540c34f", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 9.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8a7b093eb5afce540c35e", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },
    { name: 'English Language 10.0', type: 'full', lock: true, paid: true, launch: '', _id: "65b8b3fd93eb5afce540c371", setId: '65c4b45b1438c7c205d06345', link: 'https://iverse.iquanta.in/' },

  ];


  quantMockList: any[] = [
    { name: 'Accountancy 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c32861a59236452d8ab2e3', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c329c6a59236452d8ab321', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c32ad3a59236452d8ab344', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d0885aa59236452d8c2125', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d08942a59236452d8c213c', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d089f0a59236452d8c2153', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d08adda59236452d8c216a', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d08bc4a59236452d8c2181', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d08cb3a59236452d8c2198', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa6fea59236452d8d9523', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa788a59236452d8d9570', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 12.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa83da59236452d8d958f', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 13.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa8cda59236452d8d95b2', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },
    { name: 'Accountancy 14.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa95ea59236452d8d9602', setId: '65c4b68d1438c7c205d0634a', link: 'https://iverse.iquanta.in/' },

    { name: 'Business Studies 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c321fea59236452d8ab184', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c324e9a59236452d8ab201', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c325a2a59236452d8ab220', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c32667a59236452d8ab261', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a5c0a59236452d8d6359', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a64ba59236452d8d6378', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d092a5a59236452d8c22a5', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d093c9a59236452d8c22bc', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d0951ba59236452d8c22d3', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a5c0a59236452d8d6359', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },
    { name: 'Business Studies 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a64ba59236452d8d6378', setId: '65c4b6201438c7c205d06349', link: 'https://iverse.iquanta.in/' },

    { name: 'Economics 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8b5c893eb5afce540c39f', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8b84093eb5afce540c444', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8b9b793eb5afce540c457', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8be4593eb5afce540c529', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8c57d93eb5afce540c5fe', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8c43893eb5afce540c5ef', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8c67893eb5afce540c60e', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8c8b493eb5afce540c6af', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65b8ca9b93eb5afce540c70e', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a79fa59236452d8d63bb', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 12.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6a951a59236452d8d63eb', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 13.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6aac0a59236452d8d6439', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 14.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6acc1a59236452d8d64a4', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },
    { name: 'Economics 15.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6ad65a59236452d8d64cb', setId: '65c4b5651438c7c205d06347', link: 'https://iverse.iquanta.in/' },

  ]

  varcMockList: any[] = [
    { name: 'Physics 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6c37a59236452d8cd59a', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6cffa59236452d8cd5fa', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6d6aa59236452d8cd61a', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6ddda59236452d8cd63a', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6e8da59236452d8cd695', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6bbe0a59236452d8d6994', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6bd5ea59236452d8d69b7', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6bde7a59236452d8d69f5', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6be98a59236452d8d6a28', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6bf45a59236452d8d6a40', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6c032a59236452d8d6a5f', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 12.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6c0f7a59236452d8d6a82', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 13.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6c17ea59236452d8d6a96', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 14.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6c2e8a59236452d8d6ab6', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },
    { name: 'Physics 15.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6c40ea59236452d8d6ad5', setId: '65dc98d6e81081a20158b741', link: 'https://iverse.iquanta.in/' },

    { name: 'Chemistry 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9a06a59236452d8d922a', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9ad5a59236452d8d9267', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9cb3a59236452d8d92a2', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9d3da59236452d8d92df', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9dc5a59236452d8d92fe', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65ea9f5aa59236452d8d9325', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa009a59236452d8d9340', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa32ca59236452d8d93a0', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa44fa59236452d8d93fd', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa518a59236452d8d9428', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },
    { name: 'Chemistry 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaa590a59236452d8d9447', setId: '64a7c1ab2afd6e4967cd37a6', link: 'https://iverse.iquanta.in/' },

    { name: 'Biology 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd761aa59236452d8ce018', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd76eaa59236452d8ce043', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd77e5a59236452d8ce0a8', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd785ca59236452d8ce0c7', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd79eca59236452d8ce0fb', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd7ae3a59236452d8ce123', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8e17a59236452d8ce9b0', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8e94a59236452d8cea33', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8f07a59236452d8cea56', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8f7ea59236452d8cea72', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },
    { name: 'Biology 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd79eca59236452d8ce0fb', setId: '65deb673cbfc2c93538b9049', link: 'https://iverse.iquanta.in/' },

    { name: 'Mathematics 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31804a59236452d8aafaf', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c318f2a59236452d8aafd4', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31b14a59236452d8ab01e', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31bbfa59236452d8ab039', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31c99a59236452d8ab078', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31d2aa59236452d8ab08c', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31ddca59236452d8ab0a3', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31edfa59236452d8ab0d9', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c31fd3a59236452d8ab0f4', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },
    { name: 'Mathematics 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65c32080a59236452d8ab13c', setId: '65c4b5951438c7c205d06348', link: 'https://iverse.iquanta.in/' },


  ]


  lrdiMockList: any[] = [
    { name: 'Political Science 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc5f5ba59236452d8cc714', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc600aa59236452d8cc854', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc63bea59236452d8ccd12', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc663fa59236452d8cd1a3', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc6767a59236452d8cd348', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6ae84a59236452d8d64fe', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6af1ca59236452d8d6521', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6afa2a59236452d8d6540', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6b036a59236452d8d6563', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6b2b2a59236452d8d65ae', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6b372a59236452d8d6652', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 12.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6b5c9a59236452d8d66e2', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 13.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e6b729a59236452d8d676b', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },
    { name: 'Political Science 14.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eaaa5aa59236452d8d9665', setId: '65dc9825e81081a20158b740', link: 'https://iverse.iquanta.in/' },

    { name: 'History 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09b7ea59236452d8c23b6', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09c68a59236452d8c23cb', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09cffa59236452d8c23e0', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09d97a59236452d8c23f5', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09e27a59236452d8c240a', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e3144aa59236452d8d4198', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65e314ada59236452d8d41a8', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efdef2a59236452d8dd8f7', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe057a59236452d8dd916', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 10.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe0f0a59236452d8dd92d', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 11.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe1e1a59236452d8dd94c', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 12.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe2afa59236452d8dd981', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },
    { name: 'History 13.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe386a59236452d8dd9a0', setId: '65d841553d427d0eb5d77e0f', link: 'https://iverse.iquanta.in/' },

    { name: 'Geography 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd80c5a59236452d8ce2e6', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd815fa59236452d8ce30d', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd81e4a59236452d8ce33c', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd829da59236452d8ce375', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8344a59236452d8ce3a0', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8432a59236452d8ce3ec', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd84c1a59236452d8ce4fd', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd8557a59236452d8ce5f2', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },
    { name: 'Geography 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd85e2a59236452d8ce6f3', setId: '65de0cb4cbfc2c93538b9048', link: 'https://iverse.iquanta.in/' },

    { name: 'Sociology 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6b15a59236452d8cdd0b', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6c74a59236452d8cdd38', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6cf0a59236452d8cdd81', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6d68a59236452d8cddd3', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6deea59236452d8cde0c', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6e68a59236452d8cde2b', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6efea59236452d8cde5a', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },
    { name: 'Sociology 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dd6f7ba59236452d8cde7d', setId: '65de0c47cbfc2c93538b9047', link: 'https://iverse.iquanta.in/' },

    { name: 'Psychology 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65d09f37a59236452d8c2441', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc25fea59236452d8cae75', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc26a4a59236452d8cae90', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc272ca59236452d8caea7', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc27e8a59236452d8caeee', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc2874a59236452d8caf0d', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc2b1fa59236452d8caffe', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 8.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc2d04a59236452d8cb0a6', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },
    { name: 'Psychology 9.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65dc2ebba59236452d8cb0fa', setId: '65d842f83d427d0eb5d77e11', link: 'https://iverse.iquanta.in/' },

    { name: 'Legal Studies 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efe88aa59236452d8dda76', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efea80a59236452d8ddacf', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efeafaa59236452d8ddaee', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 4.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efeb9aa59236452d8ddb11', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 5.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65efec9ca59236452d8ddb34', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 6.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eff2b7a59236452d8ddc55', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },
    { name: 'Legal Studies 7.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65eff413a59236452d8ddcde', setId: '65f7ed7a5d85e6754ce19cc8', link: 'https://iverse.iquanta.in/' },

    { name: 'Agriculture 1.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65f7e9fca59236452d8e2a6a', setId: '65f7eea05d85e6754ce19cc9', link: 'https://iverse.iquanta.in/' },
    { name: 'Agriculture 2.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65f7ea84a59236452d8e2a89', setId: '65f7eea05d85e6754ce19cc9', link: 'https://iverse.iquanta.in/' },
    { name: 'Agriculture 3.0', type: 'sectional', lock: false, paid: true, launch: '', _id: '65f7ec9fa59236452d8e2ab6', setId: '65f7eea05d85e6754ce19cc9', link: 'https://iverse.iquanta.in/' },

    { name: 'PHYSICAL EDUCATION MOCK 1', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1b084bc5bc344636028a', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 2', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1d0ba0934153abe1ae1d', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 3', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1ebb4bc5bc34463602fc', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 4', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c20f44bc5bc344636033e', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 5', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c22704bc5bc344636037c', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 1', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1b084bc5bc344636028a', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 2', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1d0ba0934153abe1ae1d', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 3', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c1ebb4bc5bc34463602fc', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 4', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c20f44bc5bc344636033e', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
    { name: 'PHYSICAL EDUCATION MOCK 5', type: 'sectional', lock: false, paid: true, launch: '', _id: '673c22704bc5bc344636037c', setId: '673c781a0182efcc3d502555', link: 'https://iverse.iquanta.in/' },
  ]

  pastPapers: any[] = [
    { name: 'General Test 1.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d57d14a59236452d8c4063", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 2.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d57e28a59236452d8c409a", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 3.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d57ee2a59236452d8c40fd", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 4.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d57fc7a59236452d8c4149", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 5.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d580bfa59236452d8c4182", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 6.0', type: 'full', lock: false, paid: true, launch: '', _id: "65d836fda59236452d8c77ea", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 7.0', type: 'full', lock: false, paid: true, launch: '', _id: "65dc1fbaa59236452d8caba2", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 8.0', type: 'full', lock: false, paid: true, launch: '', _id: "65dc2248a59236452d8cac32", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 9.0', type: 'full', lock: false, paid: true, launch: '', _id: "65dc236aa59236452d8cac99", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },
    { name: 'General Test 10.0', type: 'full', lock: false, paid: true, launch: '', _id: "65dc2452a59236452d8cad11", setId: '65d8425e3d427d0eb5d77e10', link: 'https://iverse.iquanta.in/' },

  ]


  faqList: any[] = [
    {
      name: 'Is the CAT exam previous year paper enough for CAT preparation?',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        { answer: 'Yes, the CAT exam previous year paper is enough for CAT preparation as it gives insight about the CAT exam pattern. The students will get an idea about the structure, marking scheme and types of questions in different sections QA, VARC and LRDI. ', subanswers: [] },
      ]
    },
    {
      name: 'What is the difficulty level of the CAT exam paper?',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        { answer: 'The difficulty level of the CAT exam paper usually ranges from moderate to difficult. As per the CAT 2024 paper analysis, the overall difficulty level was moderate. It is expected that CAT exam paper 2025 will follow the same paper pattern and difficulty level as in 2024.', subanswers: [] },

      ]
    },
    {
      name: ' What is the medium of a CAT question paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The medium of the CAT question paper is in English. It is a computer based test for a duration of 120 minutes. The paper will consist of both MCQ and Non-MCQ questions with +3 marks for each correct answer and -3 marks for each incorrect answer.', subanswers: [

          ]
        },
      ]
    },
    {
      name: ' What are the different sections in the CAT exam paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'The different sections in the CAT exam paper are - VARC (Verbal Ability and Reading Comprehension), QA (Quantitative Ability), DILR (Data Interpretation and logical reasoning). There are a total of 68 questions with 40 minutes for each section ', subanswers: [] },
      ]
    },
    {
      name: ' What are the benefits of last years CAT exam paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'Solving last year’s CAT exam paper allows the students to practice a wide range of questions from all the sections. This in turn will increase the speed and accuracy of the candidates aspiring to appear for the CAT exam.',
          subanswers: []
        },
      ]
    },



    {
      name: ' Why to solve the CAT old paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The CAT exam has undergone various changes in the previous years therefore, it is very important to solve the CAT old paper to get a sense of the actual examination. The students will get an idea about the different types of sets and questions. ',
          subanswers: []
        },
      ]
    },
    {
      name: 'What should be the approach to solve the CAT exam previous year paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'One of the crucial factors while solving the CAT exam previous year paper is to learn how to skip and move ahead. An aspirant should first start with the easy questions first and then slowly and steadily should move towards the tough questions.',
          subanswers: []
        },
      ]
    },
    {
      name: 'Where to get the previous year CAT exam paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The candidates can find the previous year CAT exam paper on the website of iQuanta from the year 2000 to 2024. Students will get the answers as well as the solutions to these previous year CAT exam papers ',
          subanswers: []
        },
      ]
    },
    {
      name: ' By whom the CAT exam paper is prepared?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The CAT exam paper is prepared by different IIMs on the basis of rotation. For example: the CAT 2024 paper was prepared by IIM Calcutta. Also, based on previous years’ trends it is expected that the CAT 2025 paper will be prepared by IIM Kozhikode (subject to change).',
          subanswers: []
        },
      ]
    },
    {
      name: 'How to prepare for the CAT exam with last years CAT exam paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The aspirants must complete the syllabus and should have a clear understanding about the basic concepts before solving the last year’s CAT exam paper. While solving the previous year’s CAT exam papers they will get an idea about the paper pattern and difficulty level. ',
          subanswers: []
        },
      ]
    },



  ];

  faqListclat: any[] = [
    {
      name: 'Why is it important to solve CLAT previous year papers?',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        { answer: 'The candidates must practice previous year CLAT papers to understand the CLAT exam pattern, important topics, section-wise difficulty level. ', subanswers: [] },
      ]
    },
    {
      name: 'How does the CLAT exam paper help with time management?',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        { answer: 'Practicing actual CLAT exam papers will help in time management as they will have to complete the paper in the given frame. This in turn will help to improve the speed and accuracy. ', subanswers: [] },

      ]
    },
    {
      name: 'Is it important to solve the latest CLAT previous year papers?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'Yes, it is important to solve the latest CLAT previous year papers as it will give the most recent types of questions, difficulty level, trending topics, etc. ', subanswers: [

          ]
        },
      ]
    },
    {
      name: ' What types of questions are asked in the CLAT exam?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'In the CLAT exam,120 questions will be asked in total. In the UG pattern, there are five sections such as: English Language, General Knowledge and Current Affairs, Logical Reasoning, Legal Reasoning and Quantitative Skills.  ', subanswers: [] },
      ]
    },
    {
      name: 'What is the CLAT question paper difficulty level?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The difficulty level of the CLAT question papers differs every year. As per the previous years analysis, the overall difficulty level ranges from easy to moderate.',
          subanswers: []
        },
      ]
    },



    {
      name: ' Which is the toughest section in the CLAT exam?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'As per the latest data, the legal reasoning section followed by the quantitative techniques is considered to be the toughest. However, other sections are on the Moderate side. ',
          subanswers: []
        },
      ]
    },
    {
      name: 'What is the marking scheme of the CLAT exam paper?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'In the CLAT question papers, +1 mark is given for every correct answer whereas 0.25 marks will be deducted for every incorrect answer. ',
          subanswers: []
        },
      ]
    },
    {
      name: 'Which is the easiest section in the CLAT exam?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'In the CLAT exam, logical reasoning and the english language section is considered to be the easiest while the other questions consist of Moderate to difficult level questions. ',
          subanswers: []
        },
      ]
    },
    {
      name: ' What is the passing rank in the CLAT exam?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'In order to get admission into the top NLUs the aspirants should aim for 90+ marks. Top NLUs include NLSIU Bangalore, Hyderabad, NALSAR, etc.',
          subanswers: []
        },
      ]
    },
    {
      name: 'Where will the candidates get to practice CLAT previous year papers?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        {
          answer: 'The aspirants can find CLAT past year papers on the website of iQuanta for free and are available to download. ',
          subanswers: []
        },
      ]
    },



  ];

  @ViewChild("myTooltip") myTooltip!: MatTooltip;


  tabVal: any = 'full';
  mockName: any;
  token: any;
  profileData: any;
  mockDataList: any[] = [];
  selectedMock: any;
  activeIndex = 0;
  loadmore1: any = 5;
  loadmore2: any = 5;
  constructor(public router: Router, public quesService: QuesService, public dialog: MatDialog, public loginService: LoginService,
    public dashboardService: DashboardService, public matSnackBar: MatSnackBar, private titleService: Title, private metaService: Meta,
    @Inject(DOCUMENT) private dom: any, public quizService: JSONIDService, public coursesService: CoursesService,
    public cartService: CartService, public spinner: NgxSpinnerService, public formBuilder: FormBuilder,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public ac: ActivatedRoute, public constantService: ConstantService,
  public deviceService: DeviceDetectorService) { 
      if(!this.dom.URL.includes('previous-papers')){
        this.router.navigate(['/404'])
      }
      
    }

  fbgroup() {
    window.open('https://www.facebook.com/groups/Rockthecat/', '_blank')
  }


  setPaidUnPaid(purchasedCourses: any) {
    console.log(purchasedCourses)
    purchasedCourses.forEach((mock: any) => {
      if (mock.bundle_lt) {
        this.fullmockDetailList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);

          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })

        })
        this.lrdiMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.pastList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.varcMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })
        this.quantMockList.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })

        this.pastPapers.forEach((fullmock: any) => {
          let ids: any = JSON.parse(mock.bundle_lt);
          ids.forEach((bundle: any) => {
            if (bundle.split('|')[0] == fullmock._id) {
              fullmock.paid = false;
            }
          })
        })

      }
    })

    this.allMocksList = this.fullmockDetailList.concat(this.lrdiMockList.concat(this.quantMockList.concat(this.pastList.concat(this.varcMockList))))
    this.payMocks()
  }

  coursesArray: any[] = []

  getCourses() {
    this.coursesService.getEnableAndDisabledCourses().subscribe(res => {
      if (res.success) {
        this.coursesArray = res.data.filter((x: any) => !x.is_rq);
        let purchasedCourses: any[] = []
        if (this.profileData) {
          this.coursesArray.forEach(mock => {
            if (this.profileData.course_ids.includes(mock.id)) {
              purchasedCourses.push(mock)
            }
          })
          if (purchasedCourses.length > 0) {
            this.setPaidUnPaid(purchasedCourses)

          }
        }

      }
    })
  }
  mockList: any[] = []
  getMockslist() {
    this.getCourses()
    this.coursesService.getPagewiseCourses('CUET', 'Mocks', '2023').subscribe(res => {
      if (res.success) {
        this.mockList = res.data[0].course;
        let purchasedCourses: any[] = []
        if (this.profileData) {
          this.mockList.forEach(mock => {
            if (this.profileData.course_ids.includes(mock.id)) {
              purchasedCourses.push(mock)
            }
          })
          if (purchasedCourses.length > 0) {
            this.setPaidUnPaid(purchasedCourses)

          }
        }
      }
    })
  }

  goto(id: any) {
    var elemnt: any = document.getElementById(id)
    elemnt.scrollIntoView({ block: 'start' })
  }

  viewanalysis(mockObj: any) {
    this.spinner.show();
    if (this.token) {
      this.coursesService.getOtp(this.mockData.email).subscribe(res => {
        if (res.otp) {
          this.spinner.hide();
          if (this.tabVal == 'full') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          } else if (this.tabVal == 'pastpapers') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          } else {
            if (this.tabVal1 == 'quant') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'varc') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'lrdi') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            }
          }

        }
      })

    } else {
      this.spinner.hide();
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false,
        data: {campaign: this.mockName + ' Previous Papers', priority: 'Silver'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()

          } else {
            this.profileData = result;
            this.token = this.sessionStorage.getItem('usertoken');;
            this.sessionStorage.setItem('userData', JSON.stringify(result));
            this.profileData.userProfile(this.profileData)

          }
        }
      });
    }
  }

  resume(mockObj: any) {
    this.spinner.show();
    if (this.token) {
      this.coursesService.getOtp(this.mockData.email).subscribe(res => {
        if (res.otp) {
          this.spinner.hide();
          if (this.tabVal == 'full') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          } else if (this.tabVal == 'pastpapers') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          } else {
            if (this.tabVal1 == 'quant') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'varc') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'lrdi') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            }
          }


        }
      })

    } else {
      this.spinner.hide();
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false,
        data: {campaign: this.mockName + ' Previous Papers', priority: 'Silver'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()

          } else {
            this.profileData = result;
            this.token = this.sessionStorage.getItem('usertoken');;
            this.sessionStorage.setItem('userData', JSON.stringify(result));
            this.profileData.userProfile(this.profileData)

          }
        }
      });
    }
  }

  startMock(mockObj: any) {
    if (this.token) {
      this.spinner.show();
      this.coursesService.getOtp(this.mockData.email).subscribe(res => {
        if (res.otp) {
          this.spinner.hide();
          if (this.tabVal == 'full') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          } else if (this.tabVal == 'pastpapers') {
            window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
              mockObj.setId + '/' + mockObj._id)
          }
          else {
            if (this.tabVal1 == 'quant') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'varc') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            } else if (this.tabVal1 == 'lrdi') {
              window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                mockObj.setId + '/' + mockObj._id)
            }

          }
        }
      })

    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false,
        data: {campaign: this.mockName + ' Previous Papers', priority: 'Silver'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {

        } else if (typeof (result) == 'object') {
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()

          } else {
            this.profileData = result;
            this.token = this.sessionStorage.getItem('usertoken');;
            this.sessionStorage.setItem('userData', JSON.stringify(result));
            this.profileData.userProfile(this.profileData)
            this.spinner.show();
            this.coursesService.getOtp(this.mockData.email).subscribe(res => {
              if (res.otp) {
                this.spinner.hide();
                if (this.tabVal == 'full') {
                  window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                } else if (this.tabVal == 'pastpapers') {
                  window.open(mockObj.link + this.mockData.email + '/' + res.otp + '/' +
                    mockObj.setId + '/' + mockObj._id)
                } else {

                }
              }
            })

          }
        }
      });
    }
  }

  changeTab(val: any) {
    this.tabVal = val;
  }
  tabVal1: any = 'quant'
  changeTab1(val: any) {
    this.tabVal1 = val;
  }


  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.profileData = res.data[0];
        this.mockData = res.mock_login;
        this.sessionStorage.setItem('userData', JSON.stringify(this.profileData));
        this.sessionStorage.setItem('mockDataList', JSON.stringify(res.mock_login))
        this.getStatus();
        this.getMockslist()
      }
    })
  }

  loadmore() {
    if (this.tabVal == 'full') {
      this.loadmore1 = this.loadmore1 + 5;
    } else {
      this.loadmore2 = this.loadmore2 + 5;
    }
  }

  loadless() {
    if (this.tabVal == 'full') {
      this.loadmore1 = 5;
    } else {
      this.loadmore2 = 5;
    }
  }
  mockData: any;

  allMocksList: any[] = []

  payPast() {
    let mocks: any[] = [];
    this.pastList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c4b45b1438c7c205d06345",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.payPast()
  }

  payMocks() {
    let mocks: any[] = [];
    this.fullmockDetailList.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c4b45b1438c7c205d06345",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalQuant()
  }

  paySectionalQuant() {
    let mocks: any[] = [];
    let mocks1: any[] = [];
    let mocks2: any[] = [];

    this.quantMockList.forEach(mock => {
      if (!mock.paid && mock.setId == '65c32861a59236452d8ab2e3') {
        mocks.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65c4b6201438c7c205d06349') {
        mocks1.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65c4b5651438c7c205d06347') {
        mocks2.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c32861a59236452d8ab2e3",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks1.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c4b6201438c7c205d06349",
          "mocks": mocks1
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks2.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c4b5651438c7c205d06347",
          "mocks": mocks2
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalLrdi()

  }

   addInternalCRMLead(typ: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name":  this.counsellingForm.value.name ,
        "firstName":  this.counsellingForm.value.name ,
        "phone":  this.counsellingForm.value.mobile ,
        "email":  this.counsellingForm.value.email ,
        "countryCode": 91,
        "source": "Website",
        "medium": "Previous Papers",
        "campaign": typ,
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.profileData ? this.profileData.id : 9999,
        "registrationDate": this.profileData ? new Date(this.profileData.date_joined).valueOf() : new Date().valueOf(),
        "pageLocation": this.dom.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
        "registrationDevice": this.deviceService.deviceType,
        "customFields": {
          "exam": cat == 'MBA' ? this.selectedExams.join(',') : this.selectedExams1.join(','),
          "examCategory": cat,
          "examTargetYear": 2025,
          "leadPriority": "Platinum",
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "Previous Papers",
            "campaign": typ,
            adContent: "",
            "pageLocation": this.dom.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
          this.counsellingForm.reset()
        } else {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
          this.counsellingForm.reset()

        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
    })
  }

    callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.selectedCategory = [];
      this.selectedExams = [];
      this.selectedExams1 = [];
    })
  }

  counsellingForm!: FormGroup;
selectedCategory:any[]=[];
  selectedExams: any[] = []
  selectedExams1: any[] = []
examList: any[] = ['CAT', 'GDPI', 'GMAT', 'XAT', 'CMAT', 'MICAT']
  examList1: any[] = ['CUET UG', 'CUET PG', 'IPMAT', 'CLAT', 'IIT']
 getExamCategory() {
    let category: any;
    if (this.examList.includes(this.counsellingForm.value.course)) {
      category = 'MBA';
      this.selectedExams.push(this.counsellingForm.value.course)
    } else {
      category = 'After 12th';
      this.selectedExams1.push(this.counsellingForm.value.course)
    }
    return category;
  }
    submit() {

    if (this.counsellingForm.valid) {
      let reqObj = {
        name: this.counsellingForm.value.name,
        email: this.counsellingForm.value.email,
        phone_no: this.counsellingForm.value.mobile,
        course: this.counsellingForm.value.course,
        year: 2025,
        time_slot: this.counsellingForm.value.time,
      }

      this.coursesService.homeEnquiry(reqObj).subscribe(res => {
        if (res.success || res.id) {
          this.selectedCategory.push(this.getExamCategory())
          this.addInternalCRMLead('Book 1 on 1 Counselling from MBA Experts')
          this.matSnackBar.open('Thanks for reaching us. Our Team will get back to you shortly', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-success'
          })
        } else {

        }
      }, err => {
        this.matSnackBar.open(err.error.error, 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      })
    }
    else {
      if (this.counsellingForm.controls['name'].hasError('required')) {
        this.matSnackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('required')) {
        this.matSnackBar.open('Email is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('required')) {
        this.matSnackBar.open('Phone Number is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.matSnackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    
      else if (this.counsellingForm.controls['time'].hasError('required')) {
        this.matSnackBar.open('Time Slot is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('pattern')) {
        this.matSnackBar.open('Email is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('pattern')) {
        this.matSnackBar.open('Phone Number is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    }
  }

  paySectionalLrdi() {
    let mocks: any[] = [];
    let mocks1: any[] = [];
    let mocks2: any[] = [];
    let mocks3: any[] = [];
    let mocks4: any[] = [];
    let mocks5: any[] = [];
    let mocks6: any[] = [];
    let mocks7: any[] = [];

    this.lrdiMockList.forEach(mock => {
      if (!mock.paid && mock.setId == '65dc9825e81081a20158b740') {
        mocks.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65d841553d427d0eb5d77e0f') {
        mocks1.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65de0cb4cbfc2c93538b9048') {
        mocks2.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65de0c47cbfc2c93538b9047') {
        mocks3.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65d842f83d427d0eb5d77e11') {
        mocks4.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65f7ed7a5d85e6754ce19cc8') {
        mocks5.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65f7eea05d85e6754ce19cc9') {
        mocks6.push({ "_id": mock._id })
      }

      if (!mock.paid && mock.setId == '673c781a0182efcc3d502555') {
        mocks7.push({ "_id": mock._id })
      }

    })


    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65dc9825e81081a20158b740",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks1.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65d841553d427d0eb5d77e0f",
          "mocks": mocks1
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks2.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65de0cb4cbfc2c93538b9048",
          "mocks": mocks2
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks3.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65de0c47cbfc2c93538b9047",
          "mocks": mocks3
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks4.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65d842f83d427d0eb5d77e11",
          "mocks": mocks4
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks5.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65f7ed7a5d85e6754ce19cc8",
          "mocks": mocks5
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks6.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65f7eea05d85e6754ce19cc9",
          "mocks": mocks6
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks7.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "673c781a0182efcc3d502555",
          "mocks": mocks7
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.paySectionalVarc()
  }

  paySectionalVarc() {
    let mocks: any[] = [];
    let mocks1: any[] = [];
    let mocks2: any[] = [];
    let mocks3: any[] = [];

    this.varcMockList.forEach(mock => {
      if (!mock.paid && mock.setId == '65dc98d6e81081a20158b741') {
        mocks.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '64a7c1ab2afd6e4967cd37a6') {
        mocks1.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65deb673cbfc2c93538b9049') {
        mocks2.push({ "_id": mock._id })
      }
      if (!mock.paid && mock.setId == '65c4b5951438c7c205d06348') {
        mocks3.push({ "_id": mock._id })
      }
    })

    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65dc98d6e81081a20158b741",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks1.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "64a7c1ab2afd6e4967cd37a6",
          "mocks": mocks1
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    if (mocks2.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65deb673cbfc2c93538b9049",
          "mocks": mocks2
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }


    if (mocks3.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65c4b5951438c7c205d06348",
          "mocks": mocks3
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
    this.payPastPapers()
  }

  payPastPapers() {
    let mocks: any[] = [];
    this.pastPapers.forEach(mock => {
      if (!mock.paid) {
        mocks.push({ "_id": mock._id })
      }
    })
    if (mocks.length > 0) {
      let reqObj = {
        "singleSet": {
          "_id": "65d8425e3d427d0eb5d77e10",
          "mocks": mocks
        }
      }
      this.cartService.paymock(this.token, { mockids: reqObj, uid: this.mockData.uid }, this.mockData.uid).subscribe(res => {

      })
    }
  }

  getpastStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '65c4b45b1438c7c205d06345'
    }
    this.coursesService.getMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.length > 0) {
        this.pastList.forEach(mock => {
          res.data.forEach((item: any) => {
            if (item.mockId == mock._id) {
              mock.status = item.status;
              mock.attemptId = item.attemptId;
            }
          })
        })
      }
    })
    // this.getxatstatus()
    this.getSectionalQuantStatus()
  }

  getPast() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '65c4b45b1438c7c205d06345'
    }
    this.coursesService.getMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.length > 0) {
        this.pastList.forEach(mock => {
          res.data.forEach((item: any) => {
            if (item.mockId == mock._id) {
              mock.status = item.status;
              mock.attemptId = item.attemptId;
            }
          })
        })
      }
    })
    this.getSectionalQuantStatus()
  }

  getStatus() {
    if (this.mockData) {
      let reqObj = {
        uid: this.mockData.uid,
        id: '65c4b45b1438c7c205d06345'
      }
      this.coursesService.getMockStatus(reqObj).subscribe(res => {
        if (res.success && res.data.length > 0) {
          this.fullmockDetailList.forEach(mock => {
            res.data.forEach((item: any) => {
              if (item.mockId == mock._id) {
                mock.status = item.status;
                mock.attemptId = item.attemptId;
              }
            })
          })
        }
      })
      this.getSectionalQuantStatus()
    }

  }

  getSectionalQuantStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1722afd6e4967cd3794'
    }
    this.coursesService.getSectionalMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.length > 0) {
        this.quantMockList.forEach(mock => {
          res.data.forEach((item: any) => {
            if (item.mockId == mock._id) {
              mock.status = item.status;
              mock.attemptId = item.attemptId;
            }
          })
        })
      }
    })
    this.getSectionalLrdiStatus()
  }

  getSectionalLrdiStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1e12afd6e4967cd37b4'
    }
    this.coursesService.getSectionalMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.length > 0) {
        this.lrdiMockList.forEach(mock => {
          res.data.forEach((item: any) => {
            if (item.mockId == mock._id) {
              mock.status = item.status;
              mock.attemptId = item.attemptId;
            }
          })
        })
      }
    })
    this.getSectionalVarcStatus()
  }

  getSectionalVarcStatus() {
    let reqObj = {
      uid: this.mockData.uid,
      id: '64a7c1ab2afd6e4967cd37a6'
    }
    this.coursesService.getSectionalMockStatus(reqObj).subscribe(res => {
      if (res.success && res.data.length > 0) {
        this.varcMockList.forEach(mock => {
          res.data.forEach((item: any) => {
            if (item.mockId == mock._id) {
              mock.status = item.status;
              mock.attemptId = item.attemptId;
            }
          })
        })
      }
    })
  }

  scrollto(index: any) {
    var elmnt: any = document.getElementById("subcat" + index);
    elmnt.scrollIntoView();
  }
  private sub: any;
  ngAfterViewInit() {

  }


  mergeConfig(options: Config) {
    // 기본 옵션
    const config = {
      // selector: '#accordion',
      multi: true
    };

    return { ...config, ...options };
  }


  toggle(index: number) {
    if (!this.config.multi) {
      this.faqList.filter(
        (menu, i) => i !== index && menu.active
      ).forEach(menu => menu.active = !menu.active);
    }

    this.faqList[index].active = !this.faqList[index].active;
  }

  toggle1(index: number) {
    if (!this.config.multi) {
      this.faqListclat.filter(
        (menu, i) => i !== index && menu.active
      ).forEach(menu => menu.active = !menu.active);
    }

    this.faqListclat[index].active = !this.faqListclat[index].active;
  }






  json1: any;
  json2: any;
  json3: any;
  json4: any;
  linkList: any[] = []
  getMockLinks() {
    this.coursesService.getMockLinks().subscribe(res => {
      if (res.length > 0) {
        this.linkList = res;
      }
    })
  }
  displayTooltip() {
    this.myTooltip.disabled = false;
    this.myTooltip.show()
    setTimeout(() => {
      this.myTooltip.disabled = true;
    }, 1000);
  }

  public pastPaperData: any;

  ngOnInit() {
    this.config = this.mergeConfig(this.options);
    let url;
   
    if (this.dom.URL.includes('?')) {
      let firstSplit = this.dom.URL.split('?')[0];
      url = firstSplit.split('/')
    } else {
      url = this.dom.URL.split('/');
    }
    if (url[url.length - 1] == 'free-cat-study-material') {
      this.mockName = 'Free CAT Study Material'
    } else {
      this.mockName = url[url.length - 1].split('-')[0].toUpperCase()
    }
    this.pastPaperData = this.constantService.pastPapersContent[0][url[url.length - 1].split('-')[0]]
    this.sub = this.ac.params.subscribe(params => {
      let mock = params['freequiz']
      // CAT
      if (mock == 'cat-previous-papers') {
        this.json1 = this.quizService.TestMockBreadCrumbList;
        this.json2 = this.quizService.TestMockProduct;
        this.json3 = this.quizService.TestMockFaq;

         this.counsellingForm = this.formBuilder.group({
              name: ['', Validators.required],
              email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
              mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
              course: ['', Validators.required],
              time: ['', Validators.required]
            })
        // Meta Data
    this.titleService.setTitle("CAT Previous Year Papers with Detailed Solutions [2000-2024]");
    this.metaService.updateTag( 
    { name: 'description', content: "Solving CAT previous year papers from 2000–2024 with detailed solutions, along with iQuanta CAT Classes, helps aspirants complete up to 95% of their preparation." }); 
    this.metaService.updateTag( 
    { name: 'keywords', content: 'cat previous year paper,cat pyq,cat previous year question paper,cat question paper,cat pyq topic wise,cat past year papers,CAT previous year papers,cat past year question,CAT Question Papers' });
// Canonical Link
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    head.appendChild(element);
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/test/cat-previous-papers')
// Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "CAT Previous Year Papers with Detailed Solutions [2000-2024]" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/test/cat-previous-papers' })
    this.metaService.updateTag(
      { property: 'og:description', content: "Solving CAT previous year papers from 2000–2024 with detailed solutions, along with iQuanta CAT Classes, helps aspirants complete up to 95% of their preparation." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/cat-previous-year-papers-66ebd28813653.webp' })
// Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2022-08-23T10:48:33+00:00' })
    this.metaService.updateTag(
      { property: 'article:modified_time', content: '2025-05-14T11:10:42+00:00' })
// Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "2 Hours" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "CAT Previous Year Papers with Detailed Solutions [2000-2024]" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/test/cat-previous-papers' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "Solving CAT previous year papers from 2000–2024 with detailed solutions, along with iQuanta CAT Classes, helps aspirants complete up to 95% of their preparation." });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/cat-previous-year-papers-66ebd28813653.webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

      }

      //IPMAT

      else if (mock == 'ipmat-previous-papers') {

      // Meta Data
    this.titleService.setTitle("IPMAT Previous Year Papers 2019 - 2024 By iQuanta");
    this.metaService.updateTag( 
    { name: 'description', content: "Explore our comprehensive collection of IPMAT Previous Year Papers to enhance your preparation. Dive into detailed solutions and expert analysis, tailored to boost your understanding and exam readiness." }); 
    this.metaService.updateTag( 
    { name: 'keywords', content: 'IPMAT previous year papers,IPMAT past year question,IPMAT past year papers,IPMAT past year question papers,IPMAT past year question paper,IPMAT Question Papers' });
// Canonical Link
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    head.appendChild(element);
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/test/ipmat-previous-papers')
// Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "IPMAT Previous Year Papers 2019 - 2024 By iQuanta" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/test/ipmat-previous-papers' })
    this.metaService.updateTag(
      { property: 'og:description', content: "Explore our comprehensive collection of IPMAT Previous Year Papers to enhance your preparation. Dive into detailed solutions and expert analysis, tailored to boost your understanding and exam readiness." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/jpeg' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/iquanta.jpg' })
// Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2023-04-19T10:41:33+00:00' })
    this.metaService.updateTag(
      { property: 'article:modified_time', content: '2025-02-07T11:10:22+00:00' })
// Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "7 Minutes" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "IPMAT Previous Year Papers 2019 - 2024 By iQuanta" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/test/ipmat-previous-papers' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "Explore our comprehensive collection of IPMAT Previous Year Papers to enhance your preparation. Dive into detailed solutions and expert analysis, tailored to boost your understanding and exam readiness." });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/iquanta.jpg' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/jpeg' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

      }

      //CLAT

      else if (mock == 'clat-previous-papers') {
        this.json1 = this.quizService.CLATPreviousPapers;
        // Meta Data
    this.titleService.setTitle("CLAT Previous Year Question Papers (2020-2024) - iQuanta");
    this.metaService.updateTag( 
    { name: 'description', content: "Explore our comprehensive collection of CLAT Previous Year Question Papers. This resource offers detailed insights into the exam pattern and types of questions." }); 
    this.metaService.updateTag( 
    { name: 'keywords', content: 'CLAT Previous Year Question Paper,CLAT Previous Year Paper,clat Papers,clat past year paper,clat past year question Paper,clat exam paper' });
// Canonical Link
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    head.appendChild(element);
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/test/clat-previous-papers')
// Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "CLAT Previous Year Question Papers (2020-2024) - iQuanta" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/test/clat-previous-papers' })
    this.metaService.updateTag(
      { property: 'og:description', content: "Explore our comprehensive collection of CLAT Previous Year Question Papers. This resource offers detailed insights into the exam pattern and types of questions." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/clat-previous-papers.webp' })
// Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2024-01-20T10:48:33+00:00' })
    this.metaService.updateTag(
      { property: 'article:modified_time', content: '2024-12-12T12:10:42+00:00' })
// Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "9 Minutes" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "CLAT Previous Year Question Papers (2020-2024) - iQuanta" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/test/clat-previous-papers' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "Explore our comprehensive collection of CLAT Previous Year Question Papers. This resource offers detailed insights into the exam pattern and types of questions." });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/clat-previous-papers.webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

      }

      // IIFT

      else if (mock == 'iift-previous-papers') {
        this.titleService.setTitle('Buy IIFT Exam Previous Years Papers Online | Section-wise Questions ');

        this.metaService.updateTag(
          { name: 'title', property: 'og:title', content: 'Buy IIFT Exam Previous Years Papers Online | Section-wise Questions ' })
        this.metaService.updateTag(
          { name: 'url', property: 'og:url', content: 'https://www.iquanta.in/test/iift-previous-papers' })
        this.metaService.updateTag(
          { name: 'description', property: 'og:description', content: "Buy IIFT exam past year question papers. Questions divided into sectional exam as in IIFT exam. IIFT is an entrance test for IIFT Delhi, Kolkata & Kakinada campus. " });

        this.metaService.updateTag(
          { property: 'twitter:title', content: 'Buy IIFT Exam Previous Years Papers Online | Section-wise Questions ' })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/iift-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Buy IIFT exam past year question papers. Questions divided into sectional exam as in IIFT exam. IIFT is an entrance test for IIFT Delhi, Kolkata & Kakinada campus. " });
        this.metaService.updateTag(
          { name: 'image', property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/iift-previous-papers.jpg' })
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/iift-previous-papers.jpg' })
      }

      // CMAT

      else if (mock == 'cmat-previous-papers') {
        // Meta Data
        this.titleService.setTitle("CMAT Previous Year Papers - iQuanta");
        this.metaService.updateTag(
          { name: 'description', content: "Supercharge your CMAT exam preparation with CMAT Previous Year Papers. Gain an edge with insightful practice and boost your chances of acing the CMAT exam." });
        this.metaService.updateTag(
          { name: 'keywords', content: 'CMAT exam,cmat previous year papers,CMAT Question Papers,CMAT Entrance Exam Previous Years Question Papers,cmat exam prepration,cmat papers' });
        // Canonical Link
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/cmat-previous-papers')
        // Facebook
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "CMAT Previous Year Papers - iQuanta" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/cmat-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Supercharge your CMAT exam preparation with CMAT Previous Year Papers. Gain an edge with insightful practice and boost your chances of acing the CMAT exam." });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/cmat-previous-papers.jpg' })
        // Article Publish Time
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2022-01-23T10:48:33+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2023-10-13T11:10:42+00:00' })
        // Twitter
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "7 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "CMAT Previous Year Papers - iQuanta" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/cmat-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Supercharge your CMAT exam preparation with CMAT Previous Year Papers. Gain an edge with insightful practice and boost your chances of acing the CMAT exam." });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/cmat-previous-papers.jpg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1280' })
      }

      // XAT

      else if (mock == 'xat-previous-papers') {
          // Meta Data
        this.titleService.setTitle("XAT Previous Year Papers 2016 to 2024 - iQuanta");
        this.metaService.updateTag( 
        { name: 'description', content: "Learn online XAT Previous Year Papers 2016 to 2024 from iQuanta. XAT Mock tests and exclusive decision-making sessions for XAT exam to the aspirants." }); 
        this.metaService.updateTag( 
        { name: 'keywords', content: 'XAT Previous Year Papers,XAT Previous Years Papers,XAT Question Paper,XAT Exam Previous Years Question Papers,XAT Exam Previous Years Question,xat,xat exam,xat exam question,XAT Previous Year Papers 2024' });
    // Canonical Link
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/xat-previous-papers')
    // Facebook
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "XAT Previous Year Papers 2016 to 2024 - iQuanta" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/xat-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Learn online XAT Previous Year Papers 2016 to 2024 from iQuanta. XAT Mock tests and exclusive decision-making sessions for XAT exam to the aspirants." });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/CAT-2024-.jpg' })
    // Article Publish Time
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2022-01-23T10:48:33+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2025-03-21T10:10:42+00:00' })
    // Twitter
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "12 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "XAT Previous Year Papers 2016 to 2024 - iQuanta" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/xat-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Learn online XAT Previous Year Papers 2016 to 2024 from iQuanta. XAT Mock tests and exclusive decision-making sessions for XAT exam to the aspirants." });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/CAT-2024-.jpg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
      }

      // SNAP

      else if (mock == 'snap-previous-papers') {
          // Meta Data
        this.titleService.setTitle("SNAP Previous Year Papers 2015 – 2024");
        this.metaService.updateTag( 
        { name: 'description', content: "Enhance your SNAP preparation with our collection of SNAP Previous Year Papers. Familiarize yourself with the exam pattern, question types, and time management." }); 
        this.metaService.updateTag( 
        { name: 'keywords', content: 'SNAP Previous Year Papers,snap papers,snap paper,snap question paper,snap exam,snap exam previous paper,snap previous papers,snap past year papers,snap past year question papers' });
    // Canonical Link
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/snap-previous-papers')
    // Facebook
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "SNAP Previous Year Papers 2015 – 2024" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/snap-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Enhance your SNAP preparation with our collection of SNAP Previous Year Papers. Familiarize yourself with the exam pattern, question types, and time management." });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/snap-previous-papers.jpeg' })
    // Article Publish Time
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2022-02-22T10:48:33+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2025-04-28T11:10:42+00:00' })
    // Twitter
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "12 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "SNAP Previous Year Papers 2015 – 2024" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/snap-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Enhance your SNAP preparation with our collection of SNAP Previous Year Papers. Familiarize yourself with the exam pattern, question types, and time management." });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/snap-previous-papers.jpeg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
      }

      //   TISS

      else if (mock == 'tiss-previous-papers') {
        // Meta Data
        this.titleService.setTitle("TISS Past Year Question Papers - iQuanta");
        this.metaService.updateTag(
          { name: 'description', content: "Access TISS Past Year Question Papers for effective exam preparation. Boost your chances of success with valuable insights and practice. Get ready to excel in the TISS exam" });
        this.metaService.updateTag(
          { name: 'keywords', content: 'TISS Past Year Question Papers,TISS Past Year papers,TISS Past Year Question Paper,tiss question paper,TISS previous year papers,Past year papers of TISS exam' });
        // Canonical Link
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/tiss-previous-papers')
        // Facebook
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "TISS Past Year Question Papers - iQuanta" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/tiss-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Access TISS Past Year Question Papers for effective exam preparation. Boost your chances of success with valuable insights and practice. Get ready to excel in the TISS exam" });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/tiss-previous-papers.jpg' })
        // Article Publish Time
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2022-01-23T10:48:33+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2023-10-13T11:10:42+00:00' })
        // Twitter
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "12 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "TISS Past Year Question Papers - iQuanta" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/tiss-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Access TISS Past Year Question Papers for effective exam preparation. Boost your chances of success with valuable insights and practice. Get ready to excel in the TISS exam" });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/tiss-previous-papers.jpg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
      }

      // iConcept

      else if (mock == 'iconcept') {
        // Meta Data
        this.router.navigateByUrl('/test/' + 'free-cat-study-material')
      }

      // 
      else if (mock == 'free-cat-study-material') {
        this.router.navigate(['/free-cat-study-material'])
      }

      // NMAT

      else if (mock == 'nmat-previous-papers') {
       // Meta Data
        this.titleService.setTitle("NMAT Previous Year Papers 2015 – 2024");
        this.metaService.updateTag( 
        { name: 'description', content: "Enhance your NMAT exam readiness with NMAT Previous Year Papers. Gain valuable insights and practice for success. Access the key to acing the NMAT exam." }); 
        this.metaService.updateTag( 
        { name: 'keywords', content: 'NMAT previous year papers,NMAT Question Papers,NMAT Exam Previous Years Question Papers,nmat papers,namt exam,nmat questin paper,NMAT past Year Papers,NMAT pyqs' });
    // Canonical Link
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/nmat-previous-papers')
    // Facebook
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "NMAT Previous Year Papers 2015 – 2024" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/nmat-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Enhance your NMAT exam readiness with NMAT Previous Year Papers. Gain valuable insights and practice for success. Access the key to acing the NMAT exam." });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/nmat-previous-papers.jpeg' })
    // Article Publish Time
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2022-01-22T10:48:33+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2025-04-28T11:10:42+00:00' })
    // Twitter
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "5 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "NMAT Previous Year Papers 2015 – 2024" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/nmat-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Enhance your NMAT exam readiness with NMAT Previous Year Papers. Gain valuable insights and practice for success. Access the key to acing the NMAT exam.." });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/nmat-previous-papers.jpeg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '720' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1280' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
      }

      // IPMAT

      else if (mock == 'ipmat-previous-papers') {
        this.titleService.setTitle('IPMAT Exam Previous Years Question Papers from iQuanta | Mock Tests');

        this.metaService.updateTag(
          { name: 'title', property: 'og:title', content: 'IPMAT Exam Previous Years Question Papers from iQuanta | Mock Tests' })
        this.metaService.updateTag(
          { name: 'url', property: 'og:url', content: 'https://www.iquanta.in/test/ipmat-previous-papers' })
        this.metaService.updateTag(
          { name: 'description', property: 'og:description', content: "Buy online IPMAT Exam Previous Years Question Papers from iQuanta. Study online for IPMAT exam with videos, practice sessions, mocks & personal mentorship." });

        this.metaService.updateTag(
          { property: 'twitter:title', content: 'IPMAT Exam Previous Years Question Papers from iQuanta | Mock Tests' })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/ipmat-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Buy online IPMAT Exam Previous Years Question Papers from iQuanta. Study online for IPMAT exam with videos, practice sessions, mocks & personal mentorship." });
        this.metaService.updateTag(
          { name: 'image', property: 'og:image', content: 'https://media.iquanta.in/ui_images/previewimages/snap-previous-papers.jpg' })
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/previewimages/snap-previous-papers.jpg' })
      }

      // CUET

      else if (mock == 'cuet-previous-papers') {
        this.json4 = this.quizService.CuetPastPapers;
        // Meta Data
        this.titleService.setTitle("CUET Previous Year Question Paper 2022 - 2025 | iQuanta");
        this.metaService.updateTag(
          { name: 'description', content: "Get the full set of CUET previous papers and make your preparation even stronger. Searched for solved and unsolved papers, study material to crack CUET, and expert advice to grab success." });
        this.metaService.updateTag(
          { name: 'keywords', content: 'cuet question paper,cuet Previous Year Question Paper,cuet Previous Year Paper ' });
        const head = this.dom.getElementsByTagName('head')[0];
        var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
        head.appendChild(element);
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', 'https://www.iquanta.in/test/cuet-previous-papers')
        this.metaService.updateTag(
          { property: 'og:type', content: "website" })
        this.metaService.updateTag(
          { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
        this.metaService.updateTag(
          { property: 'og:title', content: "CUET Previous Year Question Paper 2022 - 2025 | iQuanta" })
        this.metaService.updateTag(
          { property: 'og:url', content: 'https://www.iquanta.in/test/cuet-previous-papers' })
        this.metaService.updateTag(
          { property: 'og:description', content: "Get the full set of CUET previous papers and make your preparation even stronger. Searched for solved and unsolved papers, study material to crack CUET, and expert advice to grab success." });
        this.metaService.updateTag(
          { property: 'og:image:height', content: '758' })
        this.metaService.updateTag(
          { property: 'og:image:width', content: '1600' })
        this.metaService.updateTag(
          { property: 'og:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'og:image', content: 'https://media.iquanta.in/ui_images/iquanta-featured.jpeg' })
        this.metaService.updateTag(
          { property: 'article:published_time', content: '2024-10-07T11:10:42+00:00' })
        this.metaService.updateTag(
          { property: 'article:modified_time', content: '2024-10-22T12:10:42+00:00' })
        this.metaService.updateTag(
          { property: 'twitter:label2', content: "Est. reading time" })
        this.metaService.updateTag(
          { property: 'twitter:data2', content: "7 Minutes" })
        this.metaService.updateTag(
          { property: 'twitter:title', content: "CUET Previous Year Question Paper 2022 - 2025 | iQuanta" })
        this.metaService.updateTag(
          { property: 'twitter:url', content: 'https://www.iquanta.in/test/cuet-previous-papers' })
        this.metaService.updateTag(
          { property: 'twitter:description', content: "Get the full set of CUET previous papers and make your preparation even stronger. Searched for solved and unsolved papers, study material to crack CUET, and expert advice to grab success." });
        this.metaService.updateTag(
          { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/iquanta-featured.jpeg' })
        this.metaService.updateTag(
          { property: 'twitter:image:height', content: '758' })
        this.metaService.updateTag(
          { property: 'twitter:image:type', content: 'image/jpeg' })
        this.metaService.updateTag(
          { property: 'twitter:image:width', content: '1600' })
      }
    });

    this.getMockslist()
    this.getMockLinks()


    // if (this.mockName == 'ICONCEPT') {
    //   this.mockName = 'iConcept'
    // }

    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.getProfile()

    }
    this.getMocks();

    // window.scrollTo(0, 0)
  }

  changeQuiz(ev: any) {
    this.mockName = ev.split('-')[0].toUpperCase();
    this.pastPaperData = this.constantService.pastPapersContent[0][ev.split('-')[0]]
    // if (this.mockName == 'ICONCEPT') {
    //   this.mockName = 'iConcept'
    // }
    this.mockDataList = [];
    this.selectedMock = '';
    this.activeIndex = 0;
    this.getMocks();
  }

  changeQuiz1(ev: any) {
    this.mockName = ev.split('-')[0].toUpperCase();
    this.pastPaperData = this.constantService.pastPapersContent[0][ev.split('-')[0]]

    // if (this.mockName == 'ICONCEPT') {
    //   this.mockName = 'iConcept'
    // }
    this.mockDataList = [];
    this.selectedMock = '';
    this.activeIndex = 0;
    this.getMocks();
  }


  getMocks() {
    this.quesService.getMocks(this.mockName == 'Free CAT Study Material' ? 'iConcept' : this.mockName).subscribe(res => {
      if (res.length > 0) {
        this.mockDataList = res;
        this.mockDataList.forEach(mock => {
          mock.mocks.forEach((item: any) => {
            this.getsections(item)
          })
        })
      }
    })
  }

  getsections(mock: any) {
    this.quesService.getSections(mock.mock_id).subscribe(res => {
      if (res.length > 0) {
        mock.sections = res;
        // mock.sections.forEach(sect=>{
        //   if(sect.section_details.status){

        //     this.activeIndex  =  mock.sections.indexOf(sect)
        //   }
        // })
      }
    })

  }

  icatmock() {
    if (this.token) {
      this.router.navigate(['/dashboard/my-courses'])
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false,
        data: {campaign: this.mockName + ' Previous Papers', priority: 'Silver'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {
          if (this.sessionStorage.getItem('mobilefbuser')) {
            let reqObj = {
              first_name: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).firstName,
              last_name: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).lastName,
              email: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).email,
              id: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).id
            }
            this.fbLogin(reqObj)
          } else {

          }

        } else if (typeof (result) == 'object') {
          // this.gmaillogin(result)
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()
            setTimeout(() => {
              this.router.navigate(['/dashboard/my-courses'])

            }, 500)

            // this.router.navigate(['/dashboard/freemocks'])
          } else {
            this.gmaillogin(result)
          }
        }
      });
    }
  }

  gmaillogin(reqObj: any) {
    let reqData = {
      id: reqObj.google_id,
      username: reqObj.name,
      email: reqObj.email,
      gmail_pic: reqObj.google_pic
    }
    this.loginService.gmail_login(reqData).subscribe(res => {
      if (res.success) {
        this.profileData = reqData;
        this.token = res.key;
        this.sessionStorage.setItem('usertoken', this.token);
        this.sessionStorage.setItem('userData', JSON.stringify(reqData));
        this.router.navigate(['/dashboard/freemocks'])
      }
    })
  }

  startQuiz() {
    if (this.token) {
      this.router.navigate(['/dashboard/freemocks'])
    } else {
      const dialogRef = this.dialog.open(LoginModal, {
        width: '750px',
        panelClass: 'login_modal',
        autoFocus: false,
        data: {campaign: this.mockName + ' Previous Papers', priority: 'Silver'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == 'yes') {
          if (this.sessionStorage.getItem('mobilefbuser')) {
            let reqObj = {
              first_name: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).firstName,
              last_name: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).lastName,
              email: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).email,
              id: JSON.parse(this.sessionStorage.getItem('mobilefbuser')).id
            }
            this.fbLogin(reqObj)
          } else {

          }

        } else if (typeof (result) == 'object') {
          // this.gmaillogin(result)
          if (this.sessionStorage.getItem('usertoken')) {
            this.token = this.sessionStorage.getItem('usertoken');
            this.getProfile()
            setTimeout(() => {
              this.router.navigate(['/dashboard/freemocks'])
            }, 500)
          } else {
            this.gmaillogin(result)
          }
        }
      });
    }
  }

  fbLogin(userInfo: any) {
    let reqObj = {
      username: userInfo.first_name + userInfo.last_name,
      firstname: userInfo.first_name,
      last_name: userInfo.last_name,
      email: userInfo.email,
      id: userInfo.id,
      facebook_pic: userInfo.picture.data.url
    }
    this.loginService.login(reqObj).subscribe(res => {
      if (res.success) {
        this.sessionStorage.removeItem('mobilefbuser')
        this.token = res.key;
        this.sessionStorage.setItem('usertoken', this.token);
        this.sessionStorage.setItem('userData', JSON.stringify(reqObj));
        this.router.navigate(['/dashboard/freemocks'])
      }
    })
  }

  openMock(mockobj: any) {
    this.selectedMock = mockobj.sections[0];
  }


  openSection(sectionObj: any, index: any) {
    this.selectedMock = sectionObj;
    this.activeIndex = index;
  }
  encryptSecretKey = "iquantaEncrypt";
  qa(section: any, mock: any) {
    console.log(mock)
    this.sessionStorage.removeItem('selMock')
    this.sessionStorage.setItem('selMock', JSON.stringify({ mockid: mock.mock_id, section: section, mockname: mock.mock_name }))
    // let el:any = this.mockName.toLowerCase() + '-' + section.section_details.section_name + '-' + mock.mock_id + '-'+ section.id
    // setTimeout(() => {
    //   history.pushState('data to be passed', 'Title of the page', 'question-paper/' + el);
    // }, 20);
    setTimeout(() => {
      history.pushState('data to be passed', 'Title of the page', 'qa/' + this.mockName.toLowerCase() + '/'
        + mock.mock_name.toLowerCase().replace(/ /g, '-') + '/'
        + CryptoJS.AES.encrypt((mock.mock_id).toString(), this.encryptSecretKey).toString().replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l')
        + '/' +
        CryptoJS.AES.encrypt((section.id).toString(), this.encryptSecretKey).toString().replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l'));
    }, 20);
    setTimeout(() => {
      location.reload()
    }, 50);

  }

  analysis(section: any, mock: any) {
    this.sessionStorage.removeItem('selMock')
    this.sessionStorage.setItem('selMock', JSON.stringify({ mockid: mock.mock_id, section: section, mockname: mock.mock_name }))
    this.router.navigate(['analysis/' + this.mockName.toLowerCase() + '/'
      + mock.mock_name.toLowerCase().replace(/ /g, '-') + '/'
      + CryptoJS.AES.encrypt((mock.mock_id).toString(), this.encryptSecretKey).toString().replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l')
      + '/' +
      CryptoJS.AES.encrypt((section.id).toString(), this.encryptSecretKey).toString().replace(/\+/g, 'p1L2u3S').replace(/\//g, 's1L2a3S4h').replace(/=/g, 'e1Q2u3A4l')])
  }

  viewResult(mock: any) {
    this.sessionStorage.setItem('testmockid', mock.mock_id)
    this.sessionStorage.setItem('testsectionid', mock.sections[this.activeIndex].id)

    let reqobj = { mockname: mock.mock_name, result: '' }
    this.sessionStorage.setItem('mockresult', JSON.stringify(reqobj))

    this.router.navigate(['/result'])

  }

}
